import axios from 'axios';
import { getOrg } from './org';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Every request carries the active company so the backend scopes data.
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['X-Org'] = getOrg();
  return config;
});

export default api;

// Normalize an axios/FastAPI error to a plain string for toasts.
// FastAPI's Pydantic v2 422 returns detail as an array of {type, loc, msg, input, url}.
// Rendering that directly in a toast crashes React ("Objects are not valid as a React child").
export function errMsg(e, fallback = 'Request failed') {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    const parts = d.map(x => (x && typeof x === 'object' && x.msg) ? x.msg : String(x));
    return parts.join('; ') || fallback;
  }
  if (d && typeof d === 'object') return d.msg || d.message || JSON.stringify(d);
  return e?.message || fallback;
}

export const STAGE_COLORS = {
  'Referral Received':      'bg-[#D8D6E2] text-[#52475A]',
  'Paperwork Pending':      'bg-[#BAA9CA]/30 text-[#52475A]',
  'Ready for Eval':         'bg-[#BAA9CA]/45 text-[#2D2833]',
  'Pre-Auth Needed':        'bg-[#B08A3A]/30 text-[#B08A3A]',
  'Pre-Auth Pending':       'bg-[#B08A3A]/25 text-[#B08A3A]',
  'Eval Scheduled':         'bg-[#839E97]/30 text-[#839E97]',
  'Eval Completed':         'bg-[#839E97]/55 text-[#839E97]',
  'Ready for Therapy':      'bg-[#685B72] text-white',
  'Waitlisted':             'bg-[#D8D6E2] text-[#52475A]',
  'Therapy Scheduled':      'bg-[#6D857E] text-white',
  'Therapy Started':        'bg-[#839E97] text-white',
  'Therapy Started ⚠️ Pre-Auth Pending': 'bg-[#F7EFDA] text-[#2D2833]',
  'On Hold':                'bg-[#8A3A3A] text-white',
  'On Hold — Pre-Auth Pending': 'bg-[#8A3A3A] text-white',
};

export function stageClass(stage) {
  if (!stage) return 'bg-[#E8E5EC] text-[#685B72]';
  if (stage.startsWith('Inactive')) return 'bg-[#E8E5EC] text-[#685B72]';
  if (stage.startsWith('On Hold')) return 'bg-[#8A3A3A] text-white';
  if (stage.startsWith('Therapy Started')) return 'bg-[#839E97] text-white';
  return STAGE_COLORS[stage] || 'bg-[#D8D6E2] text-[#52475A]';
}

export const URGENCY_STYLES = {
  HIGH: 'bg-[#8A3A3A]/15 text-[#8A3A3A] border-[#8A3A3A]/40',
  MED:  'bg-[#B08A3A]/20 text-[#B08A3A] border-[#B08A3A]/40',
  LOW:  'bg-[#839E97]/15 text-[#839E97] border-[#839E97]/30',
};
